import type { ApiHook } from 'utils/request/useApi';
import type { Snmp } from '../../SnmpModel';

export type SnmpResponse = {
  snmp: Snmp;
};

export function getSnmp(api: ApiHook) {
  return api.request<SnmpResponse>({
    url: '/settings',
    method: 'GET',
  });
}
